import React from "react";
import { Link } from "gatsby";
import Dinakajoy from "../assets/images/dinakajoy5.png";
import * as styles from "../assets/styles/sidebar.module.scss";

const Sidebar = ({ siteMetadata }) => (
  <>
    <aside className={styles.sidebar}>
      <header>
        <div className={styles.about}>
          <div className={styles.cover_author_image}>
            <Link to="/">
              <img src={Dinakajoy} alt={siteMetadata.author} />
            </Link>
          </div>
          <div className={styles.author_name}>{siteMetadata.author}</div>
          <p>
            {siteMetadata.description}... <br />
            <a href="https://www.dinakajoy.com/" target="_blank">
              More About Me
            </a>
          </p>
        </div>
        <div className={styles.link_wrapper}>
          <div className={styles.link}>
            <Link to="/">All Posts</Link>
          </div>
          <div className={styles.link}>
            <Link to="/all-categories">All Categories</Link>
          </div>
          <div className={styles.link}>
            <Link to="/all-tags">All Tags</Link>
          </div>
          <div className={styles.link}>
            <Link to="/account">Account</Link>
          </div>
        </div>
      </header>
      <footer>
        <div className={styles.contact}>
          <h3 className={styles.contact_title}>Contact me</h3>
          <ul>
            <li>
              <a
                href={`https://github.com/${siteMetadata.socials}`}
                target="_blank"
              >
                <i className="fa fa-github" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={`https://linkedin.com/in/${siteMetadata.socials}`}
                target="_blank"
              >
                <i className="fa fa-linkedin" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={`https://twitter.com/${siteMetadata.socials}`}
                target="_blank"
              >
                <i className="fa fa-twitter" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a href={`mailto:${siteMetadata.email}`} target="_blank">
                <i className="fa fa-envelope-o" aria-hidden="true" />
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.copyright}>
          <p>
            {new Date().getFullYear()} &copy; {siteMetadata.author}
          </p>
        </div>
      </footer>
    </aside>
  </>
);

export default Sidebar;
